var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share (1) 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.4542 5.37691L11.8323 1.75506C11.5335 1.45622 11.2303 1.30469 10.9314 1.30469C10.5209 1.30469 10.0417 1.61687 10.0417 2.49675V3.72978C7.41028 3.84447 4.95294 4.92362 3.07869 6.79778C1.09356 8.78278 0.0001875 11.422 0 14.2293C0 14.431 0.129 14.6101 0.320312 14.674C0.369156 14.6903 0.419156 14.6981 0.468688 14.6981C0.613281 14.6981 0.75325 14.631 0.8435 14.5109C3.05659 11.5651 6.38847 9.82416 10.0417 9.68672V10.9008C10.0417 11.7806 10.5209 12.0928 10.9314 12.0928H10.9315C11.2304 12.0928 11.5335 11.9413 11.8323 11.6425L15.4541 8.02059C15.8062 7.66869 16 7.19925 16 6.69875C16 6.19834 15.8062 5.72888 15.4542 5.37691Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.3f1cc403d8656549f214300faadc8efb.svg";
export { ForwardRef as ReactComponent };